// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
    display: flex;
    align-items: center;
}

/*.app body {*/
/*    font-family: -apple-system, BlinkMacSystemFont, sans-serif;*/
/*    font-size: 16px;*/
/*    -webkit-font-smoothing: antialiased;*/
/*    display: flex;*/
/*    justify-content: center;*/
/*    align-content: center;*/
/*    height: 100vh;*/
/*    width: 100vw;*/
/*}*/

.stripeApp form {
    width: 30vw;
    min-width: 500px;
    align-self: center;
    box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
    border-radius: 7px;
    padding: 40px;
}


#payment-message {
    color: rgb(105, 115, 134);
    font-size: 16px;
    line-height: 20px;
    padding-top: 12px;
    text-align: center;
}

#payment-element {
    margin-bottom: 24px;
}

/* Buttons and links */
.stripeApp button {
    background: #5469d4;
    font-family: Arial, sans-serif;
    color: #ffffff;
    border-radius: 4px;
    border: 0;
    padding: 12px 16px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: block;
    transition: all 0.2s ease;
    box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
    width: 100%;
}

.stripeApp > button:hover {
    filter: contrast(115%);
}

.stripeApp > button:disabled {
    opacity: 0.5;
    cursor: default;
}

/* spinner/processing state, errors */
.stripeApp > .spinner,
.stripeApp > .spinner:before,
.stripeApp > .spinner:after {
    border-radius: 50%;
}

.stripeApp > .spinner {
    color: #ffffff;
    font-size: 22px;
    text-indent: -99999px;
    margin: 0px auto;
    position: relative;
    width: 20px;
    height: 20px;
    box-shadow: inset 0 0 0 2px;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
}

.stripeApp > .spinner:before,
.stripeApp > .spinner:after {
    position: absolute;
    content: '';
}

.stripeApp > .spinner:before {
    width: 10.4px;
    height: 20.4px;
    background: #5469d4;
    border-radius: 20.4px 0 0 20.4px;
    top: -0.2px;
    left: -0.2px;
    -webkit-transform-origin: 10.4px 10.2px;
    transform-origin: 10.4px 10.2px;
    -webkit-animation: loading 2s infinite ease 1.5s;
    animation: loading 2s infinite ease 1.5s;
}

.stripeApp > .spinner:after {
    width: 10.4px;
    height: 10.2px;
    background: #5469d4;
    border-radius: 0 10.2px 10.2px 0;
    top: -0.1px;
    left: 10.2px;
    -webkit-transform-origin: 0px 10.2px;
    transform-origin: 0px 10.2px;
    -webkit-animation: loading 2s infinite ease;
    animation: loading 2s infinite ease;
}

@keyframes loading {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@media only screen and (max-width: 600px) {
    .app >  form {
        width: 80vw;
        min-width: initial;
    }
}
`, "",{"version":3,"sources":["webpack://./src/modules/HPP/controls/stripe/StripeApp.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA,cAAc;AACd,kEAAkE;AAClE,uBAAuB;AACvB,2CAA2C;AAC3C,qBAAqB;AACrB,+BAA+B;AAC/B,6BAA6B;AAC7B,qBAAqB;AACrB,oBAAoB;AACpB,IAAI;;AAEJ;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB;gFAC4E;IAC5E,kBAAkB;IAClB,aAAa;AACjB;;;AAGA;IACI,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,iDAAiD;IACjD,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA,qCAAqC;AACrC;;;IAGI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,gCAAgC;IAChC,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,+BAA+B;IAC/B,gDAAgD;IAChD,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,4BAA4B;IAC5B,2CAA2C;IAC3C,mCAAmC;AACvC;;AAEA;IACI;QACI,+BAA+B;QAC/B,uBAAuB;IAC3B;IACA;QACI,iCAAiC;QACjC,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ","sourcesContent":["#root {\n    display: flex;\n    align-items: center;\n}\n\n/*.app body {*/\n/*    font-family: -apple-system, BlinkMacSystemFont, sans-serif;*/\n/*    font-size: 16px;*/\n/*    -webkit-font-smoothing: antialiased;*/\n/*    display: flex;*/\n/*    justify-content: center;*/\n/*    align-content: center;*/\n/*    height: 100vh;*/\n/*    width: 100vw;*/\n/*}*/\n\n.stripeApp form {\n    width: 30vw;\n    min-width: 500px;\n    align-self: center;\n    box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),\n    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);\n    border-radius: 7px;\n    padding: 40px;\n}\n\n\n#payment-message {\n    color: rgb(105, 115, 134);\n    font-size: 16px;\n    line-height: 20px;\n    padding-top: 12px;\n    text-align: center;\n}\n\n#payment-element {\n    margin-bottom: 24px;\n}\n\n/* Buttons and links */\n.stripeApp button {\n    background: #5469d4;\n    font-family: Arial, sans-serif;\n    color: #ffffff;\n    border-radius: 4px;\n    border: 0;\n    padding: 12px 16px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    display: block;\n    transition: all 0.2s ease;\n    box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);\n    width: 100%;\n}\n\n.stripeApp > button:hover {\n    filter: contrast(115%);\n}\n\n.stripeApp > button:disabled {\n    opacity: 0.5;\n    cursor: default;\n}\n\n/* spinner/processing state, errors */\n.stripeApp > .spinner,\n.stripeApp > .spinner:before,\n.stripeApp > .spinner:after {\n    border-radius: 50%;\n}\n\n.stripeApp > .spinner {\n    color: #ffffff;\n    font-size: 22px;\n    text-indent: -99999px;\n    margin: 0px auto;\n    position: relative;\n    width: 20px;\n    height: 20px;\n    box-shadow: inset 0 0 0 2px;\n    -webkit-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    transform: translateZ(0);\n}\n\n.stripeApp > .spinner:before,\n.stripeApp > .spinner:after {\n    position: absolute;\n    content: '';\n}\n\n.stripeApp > .spinner:before {\n    width: 10.4px;\n    height: 20.4px;\n    background: #5469d4;\n    border-radius: 20.4px 0 0 20.4px;\n    top: -0.2px;\n    left: -0.2px;\n    -webkit-transform-origin: 10.4px 10.2px;\n    transform-origin: 10.4px 10.2px;\n    -webkit-animation: loading 2s infinite ease 1.5s;\n    animation: loading 2s infinite ease 1.5s;\n}\n\n.stripeApp > .spinner:after {\n    width: 10.4px;\n    height: 10.2px;\n    background: #5469d4;\n    border-radius: 0 10.2px 10.2px 0;\n    top: -0.1px;\n    left: 10.2px;\n    -webkit-transform-origin: 0px 10.2px;\n    transform-origin: 0px 10.2px;\n    -webkit-animation: loading 2s infinite ease;\n    animation: loading 2s infinite ease;\n}\n\n@keyframes loading {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n@media only screen and (max-width: 600px) {\n    .app >  form {\n        width: 80vw;\n        min-width: initial;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
